export default __webpack_public_path__ + "static/media/avocado.750ba6cc.png";